export const auth = {
    onAuthStateChanged: (callback) => {
      // Simulate a logged-in user
      callback({ displayName: "Test User" });
      return () => {}; // Return a dummy unsubscribe function
    }
  };